import * as C from "../../Constants/PricingConstants";

// Holds the list (array) for a CRUD entity.
const makeListReducer =
  (REQ: string, OK: string, FAIL: string) =>
  (state = { loading: false, rows: [] as any[] }, action: any) => {
    switch (action.type) {
      case REQ:
        return { ...state, loading: true };
      case OK:
        return { loading: false, rows: action.data || [] };
      case FAIL:
        return { loading: false, rows: [] };
      default:
        return state;
    }
  };

// Tracks the result of a create/update/delete (or preview/apply). `status` flips
// true only on success, so success-effects can watch it.
const makeMutationReducer =
  (REQ: string, OK: string, FAIL: string) =>
  (
    state = { loading: false, status: false, data: null as any },
    action: any
  ) => {
    switch (action.type) {
      case REQ:
        return { loading: true, status: false, data: null };
      case OK:
        return { loading: false, status: true, data: action.data };
      case FAIL:
        return { loading: false, status: false, data: null };
      default:
        return state;
    }
  };

// --- Feature Catalog ---
export const FeatureCatalogListReducer = makeListReducer(
  C.FEATURE_CATALOG_LIST_REQUEST,
  C.FEATURE_CATALOG_LIST_SUCCESS,
  C.FEATURE_CATALOG_LIST_FAIL
);
export const FeatureCatalogMutationReducer = makeMutationReducer(
  C.FEATURE_CATALOG_MUTATE_REQUEST,
  C.FEATURE_CATALOG_MUTATE_SUCCESS,
  C.FEATURE_CATALOG_MUTATE_FAIL
);

// --- Calculator Presets ---
export const CalculatorPresetListReducer = makeListReducer(
  C.CALCULATOR_PRESET_LIST_REQUEST,
  C.CALCULATOR_PRESET_LIST_SUCCESS,
  C.CALCULATOR_PRESET_LIST_FAIL
);
export const CalculatorPresetMutationReducer = makeMutationReducer(
  C.CALCULATOR_PRESET_MUTATE_REQUEST,
  C.CALCULATOR_PRESET_MUTATE_SUCCESS,
  C.CALCULATOR_PRESET_MUTATE_FAIL
);

// --- Top-up Presets ---
export const TopupPresetListReducer = makeListReducer(
  C.TOPUP_PRESET_LIST_REQUEST,
  C.TOPUP_PRESET_LIST_SUCCESS,
  C.TOPUP_PRESET_LIST_FAIL
);
export const TopupPresetMutationReducer = makeMutationReducer(
  C.TOPUP_PRESET_MUTATE_REQUEST,
  C.TOPUP_PRESET_MUTATE_SUCCESS,
  C.TOPUP_PRESET_MUTATE_FAIL
);

// --- Top-up Bonus Rules ---
export const TopupBonusRuleListReducer = makeListReducer(
  C.TOPUP_BONUS_RULE_LIST_REQUEST,
  C.TOPUP_BONUS_RULE_LIST_SUCCESS,
  C.TOPUP_BONUS_RULE_LIST_FAIL
);
export const TopupBonusRuleMutationReducer = makeMutationReducer(
  C.TOPUP_BONUS_RULE_MUTATE_REQUEST,
  C.TOPUP_BONUS_RULE_MUTATE_SUCCESS,
  C.TOPUP_BONUS_RULE_MUTATE_FAIL
);

// --- Currency Credit Rates ---
export const CurrencyCreditRateListReducer = makeListReducer(
  C.CURRENCY_CREDIT_RATE_LIST_REQUEST,
  C.CURRENCY_CREDIT_RATE_LIST_SUCCESS,
  C.CURRENCY_CREDIT_RATE_LIST_FAIL
);
export const CurrencyCreditRateMutationReducer = makeMutationReducer(
  C.CURRENCY_CREDIT_RATE_MUTATE_REQUEST,
  C.CURRENCY_CREDIT_RATE_MUTATE_SUCCESS,
  C.CURRENCY_CREDIT_RATE_MUTATE_FAIL
);

// --- Charge Sync ---
export const ChargeSyncPreviewReducer = makeMutationReducer(
  C.CHARGE_SYNC_PREVIEW_REQUEST,
  C.CHARGE_SYNC_PREVIEW_SUCCESS,
  C.CHARGE_SYNC_PREVIEW_FAIL
);
export const ChargeSyncApplyReducer = makeMutationReducer(
  C.CHARGE_SYNC_APPLY_REQUEST,
  C.CHARGE_SYNC_APPLY_SUCCESS,
  C.CHARGE_SYNC_APPLY_FAIL
);
